import React from 'react';
import SEO from '../../../common/SEO';
import Layout from '../../../common/Layout';
import BreadcrumbOne from '../../../common/breadcrumb/BreadcrumbOne';
import RegisterProgramForm from '../../../components/form/register-program-form/RegisterProgramForm';
// import { Link } from 'react-router-dom';

const EventData = [
	{
		"id": 1,
		"title": "Generative RNA Design",
		"image": "generative_rna.webp",
		// "website": "https://ovet.app/",
		// "industry": "Healthcare",
		// "rating": "4.8 Google Rating",
		// "duration": "12 Weeks",
		"category": "Healthcare",
		"location": "https://livinginsilico.ca/",
		// "going": "140+",
		"company": "Living in Silico"
	}
]

const GenerativeRNADesign = ({
	showRegisterForm,
	setShowRegisterForm,
	company
	}) => {
	const eventItem = EventData[0];
	return (
		<>
			<SEO
				title={ eventItem.title }
				description=""
			/>
			<Layout>
				<BreadcrumbOne 
					title={eventItem.title}
					rootUrl="/programs/work-integrated-learning"
					parentUrl="Industry Partner Work Integrated Learning"
					currentUrl={eventItem.title}
				/>
				<div className="edu-event-details-area edu-event-details edu-section-gap bg-color-white">
					<div className="container">
						<div className="row g-5">
							<div className="col-lg-12">
								<div className="thumbnail">
									<img src={`${process.env.PUBLIC_URL}/images/project-details/${ eventItem.image }`} alt="Event Thumb" />
								</div>
							</div>
						</div>
						<div className="row g-5">
							<div className="col-lg-7">
								<div className="content">
									<h3 className="title">{ eventItem.title }</h3>
									<p>
										<strong>What is the main goal for this project?</strong><br></br>
										This project explores how artificial intelligence can be applied to accelerate scientific discovery in the field of computational biology. The goal is to develop AI-driven tools that generate and evaluate biological sequences for potential health and research applications, helping advance digital experimentation and innovation in life sciences.
									</p>
									<p className="mb-0">
										<strong>What tasks will learners need to complete to achieve the project goal?</strong><br></br>
									</p>
									<ul>
										<li>
											Prepare and organize biological sequence datasets for model training.
										</li>
										<li>
											Support the automation of data processing pipelines for bioinformatics analysis.
										</li>
										<li>
											Assist in developing and testing generative models that propose new sequence patterns.
										</li>
										<li>
											Help integrate scoring and evaluation metrics into AI model workflows.
										</li>
										<li>
											Contribute to building tools for data visualization and experimental feedback.
										</li>
									</ul>
									<p className="mb-0">
										These tasks give learners a unique opportunity to explore the intersection of AI and life sciences.
									</p>
									<p className="mb-0">
										<strong>How will you support learners in completing the project?</strong><br></br>
										Learners will work closely with mentors specializing in AI and digital health research. They will receive step-by-step guidance through structured sprints, regular check-ins, and collaborative tools. Access to cloud computing environments and prebuilt templates ensures learners gain hands-on experience while working on cutting-edge problems in an interdisciplinary setting.
									</p>
								</div>
							</div>
							<div className="col-lg-5">
								<div className="eduvibe-sidebar">
									<div className="eduvibe-widget eduvibe-widget-details">
										<h5 className="title">ABOUT INDUSTRY PARTNER</h5>
										<div className="widget-content">
											<ul>
												{/* <li><span><i className="icon-Campus"></i> { eventItem.company }</span></li> */}
												<li><span><i className="icon-Campus"></i> <a href={eventItem.location}>{ eventItem.company }</a></span></li>
												<li><span><i className="icon-presentation"></i> { eventItem.category }</span></li>
												{/* <li><span><i className="icon-map-pin-line"></i> {company ? <a href={eventItem.location}>Website</a> : eventItem.location}</span></li> */}
												<li>
													Living In Silico harnesses AI and molecular simulations to accelerate biomedical research, with a focus on RNA-protein interactions for antiviral and therapeutic discovery. By simulating molecular behavior, the company enables faster, cost-effective drug development without reliance on traditional lab experimentation.
												</li>
											</ul>
											{!company && <div className="read-more-btn mt--45">
												<a className="edu-btn btn-secondary text-center" href="https://form.jotform.com/m2mtech/wil-programs-sign-up">Register Now<i className="icon-arrow-right-line-right"></i></a>
											</div>}
										</div>
									</div>
								</div>
							</div>
							{!company && <div className="col-lg-12">
								<div className="read-more-btn text-center">
									<a className="edu-btn btn-secondary text-center" href="https://form.jotform.com/m2mtech/wil-programs-sign-up">Register Now<i className="icon-arrow-right-line-right"></i></a>
								</div>
							</div>}
						</div>
					</div>
				</div>
			</Layout>
			{showRegisterForm && <RegisterProgramForm setShowRegisterForm={setShowRegisterForm} />}
		</>
	)
}
export default GenerativeRNADesign;